var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bpb-input-text',{attrs:{"value":"1","name":"amount","type":"number","min":1,"max":999},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('a-label',{attrs:{"path":"shop.amount","is-visible":true}},[_vm._v(":")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }